import { useTranslation } from "react-i18next";

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "~/components/ui";

interface GroupActivationDialogProps {
  open: boolean;
  action: "activate" | "deactivate";
  name: string;
  processing: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

/**
 * Confirm prompt for activate / deactivate. Names the group being acted on so a
 * misclick is easy to catch (V1 used the same `deactivateX` / `activateX` copy).
 */
export function GroupActivationDialog({
  open,
  action,
  name,
  processing,
  onConfirm,
  onCancel,
}: GroupActivationDialogProps) {
  const { t } = useTranslation();
  const isDeactivate = action === "deactivate";

  return (
    <AlertDialog
      open={open}
      onOpenChange={(next) => {
        if (!next) onCancel();
      }}
    >
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{t("feature.common.confirmTitle")}</AlertDialogTitle>
          <AlertDialogDescription>
            {isDeactivate ? t("ui.deactivateX", { x: name }) : t("ui.activateX", { x: name })}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={processing}>{t("ui.cancel")}</AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm} disabled={processing}>
            {isDeactivate ? t("ui.deactivate") : t("ui.activate")}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
